import { useSearchFilterStore } from '@/entities/map'
import { Button, Dialog } from '@/shared/ui'

import { useFilter } from '../../model/filter'

export const ApplyButton = () => {
  const { filter } = useFilter()
  const actions = useSearchFilterStore(state => state.actions)

  const handleClick = () => {
    actions.update(filter)
  }

  return (
    <Dialog.Close asChild onClick={handleClick}>
      <Button size="large" fullWidth>
        적용하기
      </Button>
    </Dialog.Close>
  )
}
